import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footerComponent" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" © 2024 "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "company-button",
    href: "https://arigami.tech/",
    target: "_blank"
  }, "ARIGAMI"),
  /*#__PURE__*/_createTextVNode(". Все права защищены. ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  class: "analiticButton",
  href: "https://datalens.yandex/k54ss12f3hioa?tab=mP",
  target: "_blank"
}, "Аналитика", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, _hoisted_4))
}